export default {
  advertisingBidSessions: state => state.advertising,
  biddingBidSessions: state => state.bidding,
  unratedBidSessions: state => state.unrated,
  getAdvertisingBidSessionById: state => id => state.advertising.find(bidSession => bidSession.id === id),
  getBiddingBidSessionById: state => id => state.bidding.find(bidSession => bidSession.id === id)
}



// WEBPACK FOOTER //
// ./src/store/modules/bid-sessions/getters.js